import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"
import { ClientHeader } from "@/components/client-header"
import { ClientTabNavigation } from "@/components/client-tab-navigation"
import { GoalsChecklist } from "@/components/forms/goals-checklist"
import { ValuesReflectionForm } from "@/components/forms/values-reflection-form"
import { Page } from "@/components/page"
import { SidebarTrigger } from "@/components/ui/sidebar"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"

export const Route = createFileRoute("/_authed/_professional/professional/goals/$estateId")({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  const { estateId } = Route.useParams()

  return (
    <Page
      showMobileNavigation={false}
      headerSlot={
        <ClientHeader
          estateId={estateId}
          mobileNavigationSlot={
            <SidebarTrigger className="size-10 shrink-0 md:hidden" aria-label="Open navigation" />
          }
        />
      }
      tabSlot={<ClientTabNavigation estateId={estateId} />}
    >
      <Tabs defaultValue="goals" className="w-full">
        <TabsList>
          <TabsTrigger value="goals">{t("pages.goals.tabs.estatePlanning")}</TabsTrigger>
          <TabsTrigger value="values">{t("pages.goals.tabs.valuesLegacy")}</TabsTrigger>
        </TabsList>

        <TabsContent value="goals" className="space-y-6">
          <GoalsChecklist estateId={estateId} />
        </TabsContent>

        <TabsContent value="values" className="space-y-6">
          <ValuesReflectionForm estateId={estateId} />
        </TabsContent>
      </Tabs>
    </Page>
  )
}
